

import ReviewsViewBanner from './view/Banner.vue';
import ReviewsViewSiteRatingsList from './view/SiteRatingsList.vue';
import ReviewsViewMapSection from './view/MapSection.vue';
import ReviewsViewTabSection from './view/TabSection.vue';
import ReviewsViewFeedback from './view/Feedback.vue';
import ReviewsSkeletonBanner from './skeleton/Banner.vue';
import ReviewsSkeletonMapSection from './skeleton/MapSection.vue';
import ReviewsSkeletonTabSection from './skeleton/TabSection.vue';
import ReviewsSkeletonFeedback from './skeleton/Feedback.vue';

export default {
  name: 'ReviewsView',
  components: {
    ReviewsViewBanner,
    ReviewsViewSiteRatingsList,
    ReviewsViewMapSection,
    ReviewsViewTabSection,
    ReviewsViewFeedback,
    ReviewsSkeletonBanner,
    ReviewsSkeletonMapSection,
    ReviewsSkeletonTabSection,
    ReviewsSkeletonFeedback,
  },
  props: {
    breadcrumbs: {
      type: Array,
      default() {
        return [];
      },
    },
    bannerData: {
      type: Array,
      default() {
        return [];
      },
    },
    badgeData: {
      type: Array,
      default() {
        return [];
      },
    },
    contactDetailData: {
      type: Object,
      default() {
        return {};
      },
    },
    reviewItems: {
      type: Array,
      default() {
        return [];
      },
    },
    reviewDescription: {
      type: String,
    },
    isBadgeBannerLoading: {
      type: Boolean,
    },
    isContactDetailLoading: {
      type: Boolean,
    },
    isReviewDataLoading: {
      type: Boolean,
    },
    totalItems: {
      type: Number,
    },
    perPage: {
      type: Number,
    },
    page: {
      type: Number,
    },
    titleDetails: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  jsonld() {
    const graph = [];
    const breadcrumbs = (this.breadcrumbs || []).map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: {
        '@id': item.url,
      },
    }));
    if (breadcrumbs.length) {
      graph.push({
        '@type': 'BreadcrumbList',
        itemListElement: breadcrumbs,
      });
    }

    if (Object.values(this.isReviewDataLoading).every((value) => value === false)) {
      graph.push(
        this.getReviewsJson(),
      );
    }

    return {
      '@context': 'https://schema.org',
      '@graph': graph,
    };
  },
  methods: {
    scrollIntoViewAndWait(element) {
      return new Promise((resolve) => {
        element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
        setTimeout(resolve, 800);
      });
    },
    async handleChange() {
      const tabSection = this.$refs.tab_section;
      if (tabSection) {
        await this.scrollIntoViewAndWait(tabSection);
      }
      this.$emit('getReviewsData');
    },
    getReviewsJson() {
      const reviewsJsonLd = {
        '@context': 'https://schema.org',
        '@type': 'Product',
        name: '1StopBedrooms Reviews',
        description: 'Welcome to our 1StopBedrooms Reviews page! On this page you’ll find feedback from our customers about our service and the products we sell. Testimonials reflect our customers’ opinion about their experiences with our company. These opinions will help others make the right choice when considering where to buy from.We gather 1StopBedrooms testimonials for several reasons. First, as you consider buying from us, we want to give you a chance to read first-hand stories from customers who have been where you are now. We know that buying from an online store can seem like a leap of faith. The input you find on this page will show you what others are saying about the experience they had with 1stopbedrooms.Second, we want you to learn about the details of our furniture and services that stand out most to customers who choose us. While we are concerned with every aspect of your furniture-buying experience, these customers can relate the highlights that matter most to them. The information on this page is a deep dive into what it is like to navigate the website, order furniture, accept delivery, and contact our customer service department.What you discover when you read 1StopBedrooms testimonials is the thoughts and feelings of customers who know precisely what makes our company stand out. Their authentic stories tend to be very descriptive and highly personalized. By the time you finish reading them, you’ll have a clearer picture of what 1StopBedrooms is all about. Whether you are a new or returning customer, we are here for you! Please share your thoughts with us! Furniture is what we sell but customers are who we serve.',
        image: 'https://www.1stopbedrooms.com/skin/frontend/onestopbedrooms/default/images/1sb-svg-icons-redesign/illustration/icon-sb-logo-illustration-238x80-v3-32.svg',
      };
      if (this.titleDetails?.rating) {
        reviewsJsonLd.aggregateRating = {
          '@type': 'AggregateRating',
          // eslint-disable-next-line no-mixed-operators
          ratingValue: (Number(this.titleDetails?.rating) * 100 / 5).toFixed(1),
          reviewCount: this.titleDetails?.allReviewCount,
          bestRating: 100,
          worstRating: 0,
        };
      }
      if (this.reviewItems?.length) {
        const reviewItemsJsonLd = this.getReviews(this.reviewItems);
        reviewsJsonLd.reviews = [
          ...reviewItemsJsonLd,
        ];
      }
      return reviewsJsonLd;
    },
    getReviews(reviews) {
      const slicedReviews = (reviews || []).slice(0, 2);
      const reviewsJsonLd = (slicedReviews || []).map((item) => ({
        '@type': 'Review',
        reviewRating: {
          '@type': 'Rating',
          bestRating: '100',
          // eslint-disable-next-line no-mixed-operators
          ratingValue: Math.round((item.rating * 100 / 5)),
          worstRating: '0',
        },
        author: {
          '@type': 'Person',
          name: item.customer_name || '',
        },
        name: '1StopBedrooms Reviews',
        datePublished: this.formatDate(item.date),
        description: item.desc,
      }));
      return reviewsJsonLd;
    },
    formatDate(dateString) {
      const [month, day, year] = dateString.split('/').map(Number);
      const formattedDate = new Date(year < 100 ? 2000 + year : year, month - 1, day);
      return formattedDate.toISOString().split('T')[0];
    },
  },
};
